import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../config";

const SocialProofStrip = ({ darkMode }) => {
  const [stats, setStats] = useState({ articles: 0, reports: 0, subscribers: 0 });
  const dm = darkMode;
  useEffect(() => {
    // `__noRetry` opts this call out of the global axios retry/reconnecting
    // banner — the stats strip is purely decorative and a transient timeout
    // here must NOT make the user think the whole site is broken.
    axios
      .get(`${API}/public-stats`, { timeout: 3000, __noRetry: true })
      .then(r => setStats(r.data))
      .catch(() => {});
  }, []);
  const fmt = (n) => n >= 1000 ? `${(n / 1000).toFixed(1)}k+` : n > 0 ? `${n}+` : "—";

  return (
    <div className={`flex flex-wrap items-center gap-x-7 gap-y-2 py-3.5 border-y mb-8 ${dm ? "border-white/5" : "border-black/5"}`}>
      {[
        { value: fmt(stats.articles), label: "articles aggregated" },
        { value: fmt(stats.reports), label: "Reports & Research" },
        { value: fmt(stats.subscribers), label: "professionals subscribed" },
        { value: "12h", label: "auto-refresh cycle" },
        { value: "3 mo", label: "rolling archive" },
      ].map(({ value, label }) => (
        <div key={label} className="flex items-center gap-1.5">
          <span className={`editorial-heading text-base font-semibold ${dm ? "text-cyan-400" : "text-[#006874]"}`}>{value}</span>
          <span className={`category-tag ${dm ? "text-slate-500" : "text-[#6b7a7d]"}`}>{label}</span>
        </div>
      ))}
    </div>
  );
};

export default SocialProofStrip;
